<template>
  <div>
    <h1 class="util--screen-reader">{{ t("routes.syndicate.name") }}</h1>
    <div class="content-grid">
      <IndividualMemberSyndicateView v-if="memberStore.hasIndividualAndCoOwnerRoles()"/>
      <SyndicateCoownerOrganizationView v-else-if="memberStore.hasRole(Role.RegularSyndicateCoOwner)"
                                        :organization-id="member.organizationId"/>
      <MemberOrganizationForm v-else :organization-id="member.organizationId"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useI18n} from "vue3-i18n"
import {useMemberStore} from "@/stores/memberStore";
import MemberOrganizationForm from "@/views/member/MemberOrganizationForm.vue";
import IndividualMemberSyndicateView from "@/views/member/IndividualMemberSyndicateView.vue";
import SyndicateCoownerOrganizationView from "@/views/member/SyndicateCoownerOrganizationView.vue";
import {Role} from "@/types";

const {t} = useI18n()
const memberStore = useMemberStore()
const member = memberStore.getMember;

</script>